import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
var ProtectedRoutes = function(props) {
    var isAuthenticated = localStorage.getItem("accessToken");
    return isAuthenticated ? /*#__PURE__*/ _jsx(Outlet, {}) : /*#__PURE__*/ _jsx(Navigate, {
        to: "/login"
    });
};
export default ProtectedRoutes;
